import React from "react";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import { __DescargarArchivo } from "../../../Utils/Funciones";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";

export default function DocumentosRevocacion(props) {
  const DescargarDocumento = async (documento) => {
    CerrarNotificador();

    let resultado = await ServicioAutorizaciones.ObtengaDocumentoRevocacion(
      documento
    );

    if (resultado.archivoBase64 !== null)
      __DescargarArchivo(resultado.archivoBase64, resultado.nombreArchivo);
    else
      Notificar(
        "error",
        "Ha ocurrido un error intentando obtener el documento"
      );
  };

  return (
    <div id="Documentos" className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Documentos</h6>
      </div>
      <div className="card-body">
        <table id="tbDocumentos" className="table table-sm">
          <thead className="table-primary">
            <tr>
              <th>Nombre </th>
              <th>Tipo Documento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {props.Documentos.map((item, index) => (
              <tr key={index}>
                <td>{item.nombreArchivo}</td>
                <td>{item.tipoDocumento.descripcion}</td>
                <td className="w-25">
                  <button
                    className="btn btn-primary btn-sm"
                    title="Descargar Documento"
                    onClick={() => DescargarDocumento(item)}
                  >
                    <span className="icon">
                      <i className="fas fa-download"></i>
                    </span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
